import { render, staticRenderFns } from "./ZLYX.vue?vue&type=template&id=034742d0&scoped=true&"
import script from "./ZLYX.vue?vue&type=script&lang=js&"
export * from "./ZLYX.vue?vue&type=script&lang=js&"
import style0 from "./ZLYX.vue?vue&type=style&index=0&id=034742d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034742d0",
  null
  
)

export default component.exports